export default __webpack_public_path__ + "static/media/iconEstrela.6c58fa07.svg";